module.exports = __webpack_public_path__ + "fonts/error.svg";